import styled from 'styled-components';

import { BUTTON_SIZES, GhostButton, SecondaryButton } from 'ui/button';
import { FolderClosed } from 'ui/icons';
import { spacing, fonts } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { FiltersMenu } from './FiltersMenu';
import { FiltersTabs } from './FiltersTabs';
import { DebouncedSearchInput } from './DebouncedSearchInput';
import { WorkflowCreatorOrModifierUser } from '../types';

const StyledMeta = styled.div`
  align-items: stretch;
  display: flex;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.double};
  justify-content: space-between;

  @media all and (max-width: 1124px) {
    /* grid-template-columns: 1fr;
    row-gap: ${spacing.base}; */
  }
`;

const MetaSection = styled.div`
  flex: 0 0 auto;
  column-gap: ${spacing.half};
`;

const LeftMeta = styled(MetaSection)``;

const RightMeta = styled(MetaSection)`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-left: ${spacing.half};

  [data-test='input-wrapper'] {
    height: ${pxToRem(40)};
  }
`;

const displayContent = {
  searchPlaceholder: 'Search workflows',
  clear: 'Clear',
  newFolder: 'New folder',
};

type FiltersBarProps = {
  canClear: boolean;
  onClear: () => void;
  search: string;
  setSearch: (search: string) => void;
  statusFilterIds: string[];
  setStatusFilterIds: (statusFilterIds: string[]) => void;
  workflowTypeFilterIds: string[];
  setWorkflowTypeFilterIds: (workflowTypeFilterIds: string[]) => void;
  triggerTypeFilterIds: string[];
  setTriggerTypeFilterIds: (triggerTypeFilterIds: string[]) => void;
  workflowCreators: WorkflowCreatorOrModifierUser[];
  workflowModifiers: WorkflowCreatorOrModifierUser[];
  creatorFilterIds: string[];
  setCreatorFilterIds: (creatorFilterIds: string[]) => void;
  modifierFilterIds: string[];
  setModifierFilterIds: (modifierFilterIds: string[]) => void;
  labelFiltersIds: string[];
  setLabelFilterIds: (labelFilterIds: string[]) => void;
  onCreateFolderButtonClick: () => void;
  journeyVisitorTrackingIds: string[];
  setJourneyVisitorTrackingIds: (journeyVisitorTrackingIds: string[]) => void;
};

export const FiltersBar = ({
  canClear,
  onClear,
  search,
  setSearch,
  statusFilterIds,
  setStatusFilterIds,
  workflowTypeFilterIds,
  setWorkflowTypeFilterIds,
  triggerTypeFilterIds,
  setTriggerTypeFilterIds,
  workflowCreators,
  workflowModifiers,
  creatorFilterIds,
  setCreatorFilterIds,
  modifierFilterIds,
  setModifierFilterIds,
  labelFiltersIds,
  setLabelFilterIds,
  onCreateFolderButtonClick,
  journeyVisitorTrackingIds,
  setJourneyVisitorTrackingIds,
}: FiltersBarProps) => (
  <StyledMeta>
    <LeftMeta>
      <FiltersTabs
        statusFilterIds={statusFilterIds}
        setStatusFilterIds={setStatusFilterIds}
        workflowTypeFilterIds={workflowTypeFilterIds}
        setWorkflowTypeFilterIds={setWorkflowTypeFilterIds}
      />
    </LeftMeta>
    <RightMeta>
      <SecondaryButton size={BUTTON_SIZES.LARGE} onClick={onCreateFolderButtonClick}>
        <FolderClosed />
        <span>{displayContent.newFolder}</span>
      </SecondaryButton>

      {canClear && (
        <GhostButton onClick={onClear} tabIndex={0} size={BUTTON_SIZES.LARGE}>
          {displayContent.clear}
        </GhostButton>
      )}
      <FiltersMenu
        statusFilterIds={statusFilterIds}
        setStatusFilterIds={setStatusFilterIds}
        workflowTypeFilterIds={workflowTypeFilterIds}
        setWorkflowTypeFilterIds={setWorkflowTypeFilterIds}
        triggerTypeFilterIds={triggerTypeFilterIds}
        setTriggerTypeFilterIds={setTriggerTypeFilterIds}
        workflowCreators={workflowCreators}
        workflowModifiers={workflowModifiers}
        creatorFilterIds={creatorFilterIds}
        setCreatorFilterIds={setCreatorFilterIds}
        modifierFilterIds={modifierFilterIds}
        setModifierFilterIds={setModifierFilterIds}
        labelFiltersIds={labelFiltersIds}
        setLabelFilterIds={setLabelFilterIds}
        journeyVisitorTrackingIds={journeyVisitorTrackingIds}
        setJourneyVisitorTrackingIds={setJourneyVisitorTrackingIds}
      />
      <DebouncedSearchInput value={search} onChange={setSearch} />
    </RightMeta>
  </StyledMeta>
);
